/* eslint-disable */
import React, { useRef } from "react";
import ShortModal from "../../../../Universal/ShortModal.component";
import { Formik } from "formik";
import FormInput from "../../../../Universal/FormInput.component";
import NormalToggleInputField from "../../../../Universal/NormalToggleInputField.component";

const CreateMeetings = ({ onClose, modalStatus, setMeetingFormData }) => {
  const formRef = useRef(null);
  const handleSubmit = (e) => {
    e.preventDefault();
    formRef.current?.handleSubmit();
    formRef.current?.setSubmitting(false);
  };
  return (
    <ShortModal
      title={"Create Meeting"}
      onClose={() => onClose()}
      isOpen={modalStatus}
    >
      <Formik
        initialValues={{
          meetingMode: false,
          whome: "",
          subject: "",
          time: "",
          date: "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          setMeetingFormData(values);
          setSubmitting(false);
        }}
        innerRef={formRef}
      >
        {({ touched, errors, values, setFieldValue }) => {
          return (
            <form
              action=""
              onSubmit={handleSubmit}
              className="flex-col align-start justify-start w-full g-2"
            >
              <div className="flex-col align-start justify-start w-full g-2">
                <h3
                  className="poppins weight-500 t-20 text-align-center"
                  style={{ color: "var(--grayColor)" }}
                >
                  Create Meeting
                </h3>
                <div className="flex-col align-start justify-start w-full g-05">
                  <div className="w-full flex-row align-center justify-start">
                    <label
                      htmlFor="meeting moods"
                      style={{ color: "var(--grayColor)" }}
                      className="formInputLabel"
                    >
                      Online
                    </label>
                    <NormalToggleInputField
                      type={"checkbox"}
                      name={"meetingMode"}
                      value={values.meetingMode}
                      setFieldValue={(name, val) => {
                        setFieldValue(name, val !== "" ? "Online" : "Offline");
                      }}
                      isRequired={false}
                    />
                  </div>
                  <FormInput
                    label="Whome"
                    name="whome"
                    type="text"
                    touched={touched}
                    errors={errors}
                    className="dateInputField"
                    placeholder={"Enter whom to meet"}
                  />
                  <FormInput
                    label="Subject"
                    name="subject"
                    type="text"
                    touched={touched}
                    errors={errors}
                    placeholder={"Enter meeting purpose"}
                  />

                  <FormInput
                    label="Time"
                    name="time"
                    type="time"
                    touched={touched}
                    errors={errors}
                    className="timeInputField"
                    placeholder={"Enter meeting time"}
                  />
                  <FormInput
                    label="Date"
                    name="date"
                    type="date"
                    touched={touched}
                    errors={errors}
                    className="dateInputField"
                    placeholder={"Enter meeting Date"}
                  />
                </div>

                <button type="submit" className="memberFormSubmitBtn">
                  Create
                </button>
              </div>
            </form>
          );
        }}
      </Formik>
    </ShortModal>
  );
};

export default CreateMeetings;
